import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { BaseService } from '../services/base.service';

@Injectable({
  providedIn: 'root',
})
export class NetworkRepo extends BaseService {
  neworkUrl = environment.apiUrl + '/networks' ;

  constructor(private http: HttpClient, private logger: NGXLogger) {
    super();
  }

  exportNetworkDefinition(): Observable<any> {
    const url = `${this.neworkUrl}/export`;

    const httpOptions: any = {
      headers: this.httpHeaders(),
      responseType: 'blob' as 'json',
      observe: 'response',
    };

    return this.http.get<any>(url, httpOptions).pipe(
      catchError(this.handleServerError)
    );
  }

  importNetworkDefinition(file: any): Observable<any> {
    const url = `${this.neworkUrl}/import`;

    const httpOptions: any = {
      headers: new HttpHeaders().set(
        'Content-Type',
        'application/vnd.ms-excel'
      ),
      observe: 'response'
    };

    return this.http.post<any>(url, file, httpOptions).pipe(
      catchError(this.handleServerError)
    );
  }
}
